<template>
    <div class="ini-filter">
        <span class="ini-filter__title">{{ title }} :</span>
        <span class="ini-filter__item" v-for="item in items">
            <ini-filter-item v-bind="item" @change="updateConditions($event, item)"></ini-filter-item>
        </span>
    </div>
</template>

<script>
    import IniFilterItem from '@/components/HelpDesk/List/FilterItem'

    export default {
        data() {
            return {
                conditions: []
            }
        },

        props: {
            title: String,
            items: Array
        },

        components: {
            IniFilterItem
        },

        methods: {
            updateConditions(values, item) {
                if(values.length === 0){
                    this.$delete(this.conditions, item.name)
                }
                else{
                    this.$set(this.conditions, item.name,
                        {column_name: item.column, operator: 'e', values: values})
                }

                this.$emit('change', Object.values(this.conditions))
            }
        },
    }
</script><style lang="scss">@import "@/assets/scss/components/HelpDesk/List/_filter.scss";</style>